import { useEffect } from "react";
import { FieldValues, UseFormGetValues, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { isPosTerminalEnabled } from "../../../../../../../Utilits/utilits";

export type WithPaymentFields = {
    cash: boolean;
    card: boolean;
};

export const useOrderPayment = <T extends FieldValues>(
    pos_terminal: boolean | null | undefined,
    setValue: UseFormSetValue<T>,
    watch: UseFormWatch<T>,
    getValues: UseFormGetValues<T>,
) => {
    const paymentEnabled = isPosTerminalEnabled(pos_terminal);
    const setPaymentValue = setValue as unknown as UseFormSetValue<WithPaymentFields>;
    const watchPayment = watch as unknown as UseFormWatch<WithPaymentFields>;
    const getPaymentValues = getValues as unknown as UseFormGetValues<WithPaymentFields>;

    useEffect(() => {
        if (!paymentEnabled) {
            setPaymentValue('cash', true);
            setPaymentValue('card', false);
        }
    }, [paymentEnabled, setPaymentValue]);

    useEffect(() => {
        if (!paymentEnabled) {
            return;
        }

        const subscription = watchPayment((values, { name }) => {
            if (name === 'cash') {
                if (values.cash) {
                    setPaymentValue('card', false);
                } else if (!values.cash && !values.card) {
                    setPaymentValue('card', true);
                }
            }

            if (name === 'card') {
                if (values.card) {
                    setPaymentValue('cash', false);
                } else if (!values.card && !values.cash) {
                    setPaymentValue('cash', true);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [paymentEnabled, watchPayment, setPaymentValue]);

    const getPaymentParams = () => {
        if (!paymentEnabled) {
            return { cash: true, card: false };
        }

        return {
            cash: Boolean(getPaymentValues('cash')),
            card: Boolean(getPaymentValues('card')),
        };
    };

    return { getPaymentParams };
};
